module.exports = __webpack_public_path__ + "static/media/pg_logo_1.e7239a62.svg";